export function numberWithCommas(x) {
	let num = x;
	num = num.replace(/,/g, '');
	return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
